// components/Common/DataTableWithFilters.js
import React from 'react';
import DataTable from 'react-data-table-component';
import {
  Box,
  Typography,
  Alert,
  CircularProgress,
  TextField,
} from '@mui/material';

const DataTableWithFilters = ({
  columns,
  data,
  loading,
  error,
  onErrorClose,
  success,
  onSuccessClose,
  filterComponents,
  selectedRowsActions,
  selectedRowsCount = 0,
  onSelectedRowsChange,
  clearSelectedRows,
  expandableRows,
  expandableRowsComponent,
  noDataMessage = "No data available",
  theme,
  customStyles,
  searchText,
  onSearchChange,
  searchPlaceholder = "Search..."
}) => {

  const defaultNoDataComponent = (
    <Box textAlign="center" py={4}>
      <i className="fa fa-file-text-o fa-3x text-muted" />
      <Typography mt={2} color="text.primary">
        {noDataMessage}
      </Typography>
    </Box>
  );

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        mb={2}
        flexWrap="wrap"
        gap={2}
      >
        {filterComponents}
        {onSearchChange && (
            <TextField
                size="small"
                variant="outlined"
                placeholder={searchPlaceholder}
                value={searchText}
                onChange={onSearchChange}
                sx={{ minWidth: { xs: '100%', sm: '250px' }, marginLeft: { xs: 0, sm: 'auto' } }}
            />
        )}
      </Box>

      {selectedRowsCount > 0 && selectedRowsActions && (
        <Alert severity="info" sx={{ mb: 2 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography>{selectedRowsCount} row(s) selected</Typography>
            {selectedRowsActions}
          </Box>
        </Alert>
      )}

      {error && (
        <Alert
          severity={
            error.toLowerCase().includes("deleted") || error.toLowerCase().includes("successfully")
              ? "success"
              : "error"
          }
          sx={{ mb: 2 }}
          onClose={onErrorClose}
        >
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={onSuccessClose}>
          {success}
        </Alert>
      )}

      {loading ? (
        <Box display="flex" flexDirection="column" alignItems="center" py={4}>
          <CircularProgress size={30} />
          <Typography mt={2}>Loading data...</Typography>
        </Box>
      ) : (
        <DataTable
          columns={columns}
          data={data}
          pagination
          responsive
          highlightOnHover
          pointerOnHover
          expandableRows={expandableRows}
          expandableRowsComponent={expandableRowsComponent}
          selectableRows
          onSelectedRowsChange={onSelectedRowsChange}
          clearSelectedRows={clearSelectedRows}
          customStyles={customStyles}
          noDataComponent={defaultNoDataComponent}
          theme={theme?.palette?.mode === "dark" ? "dark" : "default"}
        />
      )}
    </Box>
  );
};

export default DataTableWithFilters;